import {
  getAuth,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  VERIFY_REQUEST,
  VERIFY_SUCCESS,
} from "../../constants/ActionType";

/*
 * ========================================
 * LOGIN ACTIONS FLOW
 * =======================================
 */
const loginRequest = () => ({
  type: LOGIN_REQUEST,
});

const loginSuccess = (user) => ({
  type: LOGIN_SUCCESS,
  payload: {
    user,
  },
});

const loginFailure = (errorMessage) => ({
  type: LOGIN_FAILURE,
  payload: {
    errorMessage,
  },
});

export const login = (email, password) => {
  return (dispatch) => {
    dispatch(loginRequest());
    const auth = getAuth();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCred) => {
        dispatch(loginSuccess(userCred.user));
      })
      .catch((error) => {
        dispatch(loginFailure(error.message));
      });
  };
};

/*
 * ========================================
 * LOGOUT ACTIONS FLOW
 * =======================================
 */
const logoutRequest = () => ({
  type: LOGOUT_REQUEST,
});

const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS,
});

const logoutFailure = (errorMessage) => ({
  type: LOGOUT_FAILURE,
  payload: {
    errorMessage,
  },
});

export const logout = () => {
  return (dispatch) => {
    dispatch(logoutRequest);
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        dispatch(logoutSuccess());
      })
      .catch((error) => {
        dispatch(logoutFailure(error.message));
      });
  };
};

/*
 * ========================================
 * VERIFICATION ACTIONS FLOW
 * =======================================
 */
const verifyRequest = () => ({
  type: VERIFY_REQUEST,
});

const verifySuccess = () => ({
  type: VERIFY_SUCCESS,
});

export const verifyAuth = () => {
  return (dispatch) => {
    dispatch(verifyRequest());
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user != null) {
        dispatch(loginSuccess(user));
      }
      dispatch(verifySuccess());
    });
  };
};
